/* eslint-disable react/prop-types */
import React, { Component } from 'react'
import Modal from 'react-modal'
import { withTranslation } from 'react-i18next'
import CoachClassCard from '../../classes/CoachClassCard/CoachClassCard'
import Loader from '../../common/loader/legacy-loaders/Op36Loader-web'
import Placeholder from '../../common/Placeholder'

class ProgramsModal extends Component {
  state = {
    loader: true,
    showCompletedPrograms: false,
  }

  togglePrograms = () => {
    this.setState({ showCompletedPrograms: !this.state.showCompletedPrograms })
  }

  renderPrograms = () => {
    const { courses, loader, golfer, current_user, t } = this.props
    const { showCompletedPrograms } = this.state

    if (loader) { return <Loader message={t('profile.programs.loadingStudentClasses')} /> }

    if (courses && courses.length > 0) {
      const filteredCourses = courses.filter(course => {
        if (showCompletedPrograms) {
          return course.is_completed
        }
        return !course.is_completed
      })
      return filteredCourses.map((course, index) => (
        <div className='col-xl-4 col-lg-6 col-md-6' key={course.id}>
          <CoachClassCard
            index={index}
            course={course}
            courseActions={this.props.course_actions}
            golfer={golfer}
            current_user={current_user}
            user={this.props.user}
            isStudentProfile
          />
        </div>
      ))
    }
    return (
      <div className='d-flex justify-content-center w-100'>
        <Placeholder
          title={t('profile.programs.noClassesToShow')}
          icon={'fa-flag'}
          subtext1={t('profile.programs.notEnrolledInClasses', {
            name: `${golfer.first_name} ${golfer.last_name}`,
          })}
        />
      </div>
    )
  }
  render() {
    const { golfer, showModal, toggleModal, t } = this.props
    const { showCompletedPrograms } = this.state
    return (
      <Modal
        isOpen={showModal}
        onRequestClose={toggleModal}
        contentLabel={t('profile.programs.modalContentLabel')}
        // style={modalStyles}
      >
        <div className='modal-header row'>
          <div className='col-11'>
            <h5 className='modal-title display-4'>
              {t('profile.programs.golferClasses', {
                name: `${golfer.first_name} ${golfer.last_name}`,
              })}
            </h5>
          </div>
          <div className='col-1'>
            <button
              type='button'
              className='close pull-right font-200'
              data-dismiss='modal'
              aria-label={t('common.close')}
              onClick={toggleModal}
            >
              <span aria-hidden='true'>✕</span>
            </button>
          </div>
        </div>

        <div className='modal-content'>
          <div className='col-md-8 mx-auto' id='input-border'>
            <div className='d-flex justify-content-end'>
              <button
                className='btn btn-link-preview'
                onClick={this.togglePrograms}
              >
                {!showCompletedPrograms
                  ? t('profile.programs.viewClassHistory')
                  : t('profile.programs.showActiveClasses')}
              </button>
            </div>
            <div className='row mt-5'>{this.renderPrograms()}</div>
          </div>
        </div>
      </Modal>
    )
  }
}

export default withTranslation()(ProgramsModal)
